export default (payload) => {
  const items = [ ...payload ]
  for (const item in items) {
    const grouppedSuppliersIdx = []
    const grouppedSuppliers = []
    if (!items[item].suppliers) { continue }

    for (const suppliers of items[item].suppliers) {
      if (suppliers && suppliers.supplier && !grouppedSuppliersIdx.includes(suppliers.supplier._id)) {
        grouppedSuppliers.push(suppliers)
        grouppedSuppliersIdx.push(suppliers.supplier._id)
      }
    }

    items[item].suppliers = grouppedSuppliers
  }

  return items
}



// WEBPACK FOOTER //
// ./src/brain/quote/load-event-list/GroupSuppliers.js